// Skip-to-content link — the first focusable element in the authenticated
// tree. Nielsen heuristic #7 (flexibility & efficiency): keyboard and screen
// reader users can jump past the persistent Header / breadcrumb chrome
// straight to the page's main landmark instead of tabbing through it on every
// route. Visually hidden until focused (see `.skip-link` in index.css).
//
// Targets `#main`, which each screen's content landmark carries. The link
// lives in AuthGate so it renders once, above every authed screen, and never
// on the login page (which has no chrome to skip).
export function SkipLink() {
  return (
    <a href="#main" className="skip-link">
      Skip to content
    </a>
  );
}
